import client from "./client";
import { getHostKey, setHostKey } from "../session/hostKey";

/** Registers this device as a host and returns its profile with the new key (once). */
export const register = (name) =>
  client.post("/Host/Register", { Name: name || null }).then((r) => r.data);

/** Who the stored host key belongs to (404 when the key is unknown). */
export const getMe = () => client.get("/Host/Me").then((r) => r.data);

/** The host's most recently used session (404 when there is none). */
export const getSession = () => client.get("/Host/Session").then((r) => r.data);

/**
 * Replaces the stored host key with a fresh one (for a key that was shared with the wrong
 * person); the old key stops working everywhere at once. Returns the profile with the new key.
 */
export const rotateKey = () => client.post("/Host/RotateKey").then((r) => r.data);

/** The stored host key, registering this device first when it has none. */
export const ensureHostKey = async () => {
  const existing = getHostKey();
  if (existing) return existing;
  const profile = await register();
  return setHostKey(profile.HostKey);
};
